import {get, post, put, del, getById, postById, putById} from './base'

/**
 * 获取本次会议会议酒店
 * @returns {Promise<unknown>}
 * @param conventionCode
 */
export function getSelectHotel(conventionCode){
    return getById('/conferenceAffairs/meetTask/hotel/meet/selectHotel/'+conventionCode)
}

/**
 * 设置会议酒店信息
 * @returns {Promise<unknown>}
 * @param data
 */
export function postSelectHotel(data){
    return postById('/conferenceAffairs/meetTask/hotel/meet/setYMeetTaskHotelMeet',data)
}

/**
 * 获取会场会议室列表
 * @returns {Promise<unknown>}
 * @param conventionCode
 */
export function getSelectSiteByConventionId(conventionCode){
    return getById('/conferenceAffairs/meetTask/hotel/meet/selectSiteByConventionId/'+conventionCode)
}

/**
 * 新增会场会议室
 * @returns {Promise<unknown>}
 * @param data
 */
export function postSelectSiteByConventionId(data){
    return postById('/conferenceAffairs/meetTask/hotel/meet/addSiteInfo',data)
}

/**
 * 更新会场会议室
 * @returns {Promise<unknown>}
 * @param data
 */
export function putSelectSiteByConventionId(data){
    return putById('/conferenceAffairs/meetTask/hotel/meet/updSiteInfo',data)
}


/**
 * 删除会场会议室
 * @returns {Promise<unknown>}
 * @param data
 */
export function delSelectSiteByConventionId(data){
    return putById('/conferenceAffairs/meetTask/hotel/meet/delSiteInfo',data)
}











/**
 * 获取本次会议住宿酒店
 * @returns {Promise<unknown>}
 * @param conventionCode
 */
export function getHotel(conventionCode){
    return getById('/conferenceAffairs/meetTask/hotel/selectHotel/'+conventionCode)
}

/**
 * 新增住宿酒店
 * @returns {Promise<unknown>}
 * @param data
 */
export function postHotel(data){
    return postById('/conferenceAffairs/meetTask/hotel/addInfo',data)
}

/**
 * 修改住宿酒店
 * @returns {Promise<unknown>}
 * @param data
 */
export function putHotel(data){
    return putById('/conferenceAffairs/meetTask/hotel/updInfo',data)
}


/**
 * 删除住宿酒店
 * @returns {Promise<unknown>}
 * @param data
 */
export function delHotel(data){
    return putById('/conferenceAffairs/meetTask/hotel/delInfo',data)
}






/**
 * 获取本次会议车辆信息
 * @returns {Promise<unknown>}
 * @param conventionCode
 */
export function getCar(conventionCode){
    return getById('/conferenceAffairs/meetTask/car/selectCar/'+conventionCode)
}

/**
 * 新增车辆信息
 * @returns {Promise<unknown>}
 * @param data
 */
export function postCar(data){
    return postById('/conferenceAffairs/meetTask/car/addInfo',data)
}

/**
 * 修改车辆信息
 * @returns {Promise<unknown>}
 * @param data
 */
export function putCar(data){
    return putById('/conferenceAffairs/meetTask/car/updInfo',data)
}


/**
 * 删除车辆信息
 * @returns {Promise<unknown>}
 * @param data
 */
export function delCar(data){
    return putById('/conferenceAffairs/meetTask/car/delInfo',data)
}
